<template>
  <div id="app">
    <title>{{ projectName }}</title>
    <!-- <router-view/> -->
    <!-- <app-header v-if="header_show"></app-header> -->
    <!-- <pagesTransition indexPagePath="/remindMeds">
      <router-view v-on:header="header" v-on:footer="footer"></router-view>
    </pagesTransition> -->

    <!-- <keep-alive :include="cashViews">
      <router-view v-on:header="header" v-on:footer="footer"></router-view>
    </keep-alive> -->
      <keep-alive>
          <router-view
            v-on:header="header"
            v-on:footer="footer"
            v-if="$route.meta.keepAlive"
          >
        </router-view>
      </keep-alive>

    <!-- <transition :name="transitionName"> -->
      <router-view
        v-on:header="header"
        v-on:footer="footer"
        v-if="!$route.meta.keepAlive"
      >
      </router-view>
    <!-- </transition> -->

    <app-footer v-if="$route.meta.showFooter&&isTabbar"></app-footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "./components/Header";
import Footer from "./components/Footer";
import remind from "./components/utils/remind";
import getSystemReminder from "./systemFolder/mixins/getSystemReminder.vue";
import getSystemTokenPage from "./systemFolder/mixins/getSystemTokenPage.vue";
import {
  DELETESYSTEMREMINDER,
  GIVEVERSION
} from "./systemFolder/SystemFuns";
export default {
  name: "App",
  mixins: [
    getSystemReminder,
    getSystemTokenPage
  ],
  data() {
    return {
      shareImg: require("../src/assets/erweima1.0.2.jpg"),
      projectName: "",
      header_show: true,
      footer_show: false,
      count: 0,
      cashViews: [
        "remindMeds",
        "healthCalendar",
        "medicalRecord",
        "virtualMedicine"
        // "my"
      ], // 需要缓存的页面
      systemReminderList: [],
      localhostData: {},
      he: "44px",
      message:'',
      map:[],
      versionData:{},
      transitionName:"slide-left"
    };
  },
  components: {
    "app-header": Header,
    "app-footer": Footer,
  },
  computed:{
    ...mapGetters("app", ["phoneModel","isHOM","isAndroid","isIOS","isTabbar"])
  },
  created() {
    if (window.location.host == "www.woaiyoufood.com") {
      this.projectName = "我爱优";
    } else {
      this.projectName = "药管家";
    }
    // 删除用药记录缓存
    localStorage.removeItem('recordList')
    localStorage.removeItem('activeTime')
  },
  beforeDestroy() {},
  mounted() {
    this.getData()
    // 记录日活
    if(this.isIOS){
      GIVEVERSION({
        webAction:'getWebVersion',
        getWebVersion:'4.1.7'
      })
    }else {
      window.getWebVersion = this.getWebVersion;
    }


    // this.utils.setStatusBarColor('#5887F3');
    window.addEventListener("offline", () => {
      this.utils.ToastSuccess("网络不可用，请检查你的网络设置");
      // 网络由正常常到异常时触发
      // sessionStorage.locationUrl=window.location.href;
      // this.utils.$routPush(this,'/noNetwork')
    });

    window.addEventListener("online", () => {
      //window.location.href=sessionStorage.locationUrl
    });
    // this.goSnapshot(); //创建是否拉起核酸页面
    // this.getBase64("../dist/static/erweima1.0.1.jpg"); //二维码 传给后端
    this.getBase64(this.shareImg);
    if (
      // location.hash.indexOf("#/selfinspection") > -1 ||
      location.hash.indexOf("#/privacyPolicy") > -1 ||
      location.hash.indexOf("#/noNetwork") > -1 ||
      location.hash.indexOf("#/gamePrivacyPolicy") > -1 ||
      location.hash.indexOf("#/water") > -1 ||
      location.hash.indexOf("#/invite") > -1 ||
      location.hash.indexOf("#/inviteRegiste") > -1
    ) {
      //用户协议不做登录校验
      return false;
    }
    let token = localStorage.getItem("token");
    if (token) {
      if (location.hash.indexOf("/remindMeds") == -1) {
        this.utils.$routPush(this, "/remindMeds");
      }
    } else {
      // this.$getSysToken()
      this.utils.visitorLogin(this);
    }
    // 切换回了前台
    this.getAndroidParames()
    document.addEventListener('visibilitychange', () => {
      console.log('进来了');
      if (document.hidden) {
        // 切换到了后台
        console.log('切换到了后台');
      } else {
        // 切换回了前台
        console.log('切换回了前台');
        this.getAndroidParames()
      }
    })
    // this.webVersion(); //传入版本进行刷新
    this.getPhoneType()
    //用户登录app时删除未删干净的的提醒
    this.getErrorRemindList();
    this.cameraBack();
  },
  methods: {
    // jumpDrink(){
    //   window.jumpDrink = () => {
    //     this.utils.$routPush(this,'/water');
    //   };
    // },
    getPhoneType(){
      if(this.isHOM){
        let data = {
          webAction: "getDevicesType",
        };
        if (window.getDevicesType && window.getDevicesType.call) {
          const result = window.getDevicesType.call(JSON.stringify(data)); //问题反馈
          this.getRecordActive(result)
        }
      }else if(this.isAndroid){
        if (window.AndroidWebView) {
          let result = window.AndroidWebView['getDevicesType']();
          this.getRecordActive(result)
        }
      }else if(this.isIOS){
        let result = navigator.userAgent || navigator.appVersion
        this.getRecordActive(result)
      }
    },
    getRecordActive(result){
      localStorage.setItem("userAgent", result);
      this.utils.recordActivityCount(this,result);
    },
    getSchemeParamesCallback(result){
      if(result){
        let data = this.isIOS?result:JSON.parse(result)
        localStorage.setItem('inviteResult',JSON.stringify(data))
        if(data.chesetId){
          this.utils.$routPush(this,`/virtualMedicine?time=${Math.round(new Date())}`)
        }
      }
    },
    getAndroidParames(){
      if(localStorage.getItem('phoneModel') == 'IOS'){
        window.getSchemeParamesCallback = this.getSchemeParamesCallback;
        if(window.webkit&& window.webkit.messageHandlers){
          window.webkit.messageHandlers.getSchemeParamesCallback.onmessage = this.getSchemeParamesCallback; // h5拉起app返回数据
        }
      }else if(localStorage.getItem('phoneModel') == 'HOM'){
        let data = {
          webAction: "getSchemeParamesCallback"
        };
        if (window.getSchemeParamesCallback && window.getSchemeParamesCallback.call) {
          const result = window.getSchemeParamesCallback.call(JSON.stringify(data));
          console.log(result,'鸿蒙');
          this.getSchemeParamesCallback(result)
        }
      }else {
        if (window.AndroidWebView) {
          let result = window.AndroidWebView['getSchemeParamesCallback']();
          console.log(result,'安卓');
          this.getSchemeParamesCallback(result)
        }
      }

    },
    getWebVersion(){
      // 获取当前版本
      return {
        version:'4.1.7'
      }
    },
    getData(){
      // 获取当前版本
      this.$get("/user/getVersion1").then(res=>{
        this.versionData = res.data
        this.$getSysVersion()
      })
    },
    $getSysToken(){
      if(this.isIOS){
        console.log('调用ios获取token');
        this.getSysToken()
      }else if(this.isHOM){
        let data = {
          webAction: "getPillStewardToken"
        };
        if (window.getPillStewardToken && window.getPillStewardToken.call) {
          const result = window.getPillStewardToken.call(JSON.stringify(data));
          if(result){
            localStorage.setItem('token',result)
            this.utils.$routPush(this, "/remindMeds");
          }else {
            this.utils.visitorLogin(this);
          }
          console.log(result,'鸿蒙');
        }
      }else {
        if (window.AndroidWebView) {
          let result = window.AndroidWebView['getPillStewardToken']();
          if(result){
            localStorage.setItem('token',result)
            this.utils.$routPush(this, "/remindMeds");
          }else {
            this.utils.visitorLogin(this);
          }
          console.log(result,'安卓');
        }
      }
    },
    handleGetTokenResult(data){
      if(data&&data.Token){
        localStorage.setItem('token',data.Token)
        this.utils.$routPush(this, "/remindMeds");
      }else {
        this.utils.visitorLogin(this);
      }
    },
    $getSysVersion(){
      if(this.isIOS){
        this.getSysVersion()
      }else if(this.isHOM){
        let data = {
          webAction: "getVersion"
        };
        if (window.getVersion && window.getVersion.call) {
          const result = window.getVersion.call(JSON.stringify(data));
          localStorage.setItem('updateVersion',this.versionData.harmonyVersion > result ?'yes':'no')
        }
      }else{
        if (window.AndroidWebView) {
          let result = window.AndroidWebView['getVersion']();
          localStorage.setItem('updateVersion',this.versionData.androidVersion > result?'yes':'no')
        }
      }
    },
    handleGetVersionResult(data){
      localStorage.setItem('updateVersion',data.update)
    },
    getCurrentUserT() {
      this.$get("/remind/getCurrentUserT", {}).then(res => {
        if (res.code == 200) {
          console.log("加上游客id");
          localStorage.setItem("noLoginId", res.data.id);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    cameraBack() {
      // 图片浏览按返回键退出浏览
      this.$preview.on("imageLoadComplete", (e, item) => {
        let _preview = this.$preview.self;
        let lookUrl = window.location.href + "&look";
        window.history.pushState(null, null, lookUrl);
        _preview.listen("close", function() {
          if (window.location.href.indexOf("&look") !== -1) {
            window.history.go(-1);
          }
        });
        window.addEventListener("popstate", function(e) {
          if (_preview !== null && _preview !== undefined) {
            _preview.close();
            _preview = null;
          }
        });
      });
    },
    getErrorRemindList() {
      this.$get("/remind/getRemindList1", {}) //查询列表数据
        .then(res => {
          if (res.code == "200") {
            for (let i in res.data) {
              if (res.data[i].localhostId) {
                let arr = res.data[i].localhostId;
                arr = res.data[i].localhostId.split(",");

                for (let ii in arr) {
                  this.systemReminderList.push({
                    name: res.data[i].medicineName,
                    localhostId: arr[ii],
                    localhostIdTemp: res.data[i].localhostId,
                    id: res.data[i].id,
                    remindWay: res.data[i].remindWay,
                    calendarId: res.data[i].calendarId,
                    index: ii
                  });
                  this.localhostData[arr[ii]] = arr[ii];
                }
              }
            }
            this.querySystemReminder();
            this.systemReminderList = this.systemReminderList.filter(
              item => item.type == "error"
            );
            // if(this.systemReminderList.length>0){
            //   this.utils.ToastSuccess(`有${this.systemReminderList.length}条未删提醒`)
            // }
          }
        }).then(() => {
          if (this.systemReminderList.length > 0) {
            this.systemReminderList.forEach(item => {
              this.deleteSystemReminder2(item);
            });
          }
        });
    },
    querySystemReminder() {
      // this.setMedicineName({id:46})
      let _data = {
        webAction: "querySystemReminder"
      };
      if (window.querySystemReminder && window.querySystemReminder.call) {
        //
        const result = window.querySystemReminder.call(JSON.stringify(_data)); //添加本地提醒
        if (result != "error" && result) {
          let list = JSON.parse(result).filter(
            item => item.content.indexOf("喝水") == -1
          );

          // if(!localStorage.getItem('isFirstWater')){
          //   console.log("喝水提醒是每天都要进来默认设置8杯 ");
          //   let waterList = JSON.parse(result).filter(
          //     item => item.content.indexOf("喝水") > -1
          //   );
          //   let ids = []
          //   if(waterList.length > 0){//针对旧数据自动创建需删除
          //     waterList.forEach(item=> {
          //       ids += item.id+',';
          //     })
          //     this.$deleteSystemReminder(ids);
          //     localStorage.setItem('isFirstWater',1)
          //   }else {
          //     localStorage.setItem('isFirstWater',1)
          //   }
          // }

          let localhostIds = "";
          for (let i in list) {
            if (!this.localhostData[list[i].id]) {
              if (list[i].content && list[i].content.split(":")[0]) {
                this.systemReminderList.unshift({
                  localhostId: list[i].id,
                  type: "error",
                  name:
                    list[i].content.split(":")[0] +
                    this.getTriggerTime(list[i].triggerTime)
                });
              }
            } else {
              this.setMedicineName(list[i]);
            }
            localhostIds += list[i].id + ",";
            //this.utils.ToastSuccess(localhostIds)
            if (localhostIds) {
              //localhostIds = localhostIds.substr(0, localhostIds.length - 1);
              //this.deleteSystemReminder(localhostIds)//删除脏数据
            }
          }
        } else {
          // localStorage.setItem('isFirstWater',1)
          this.utils.ToastSuccess(result);
        }
        console.log(result);
      }
    },
    getTriggerTime(time) {
      let date = new Date(time);
      let hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let mf =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      return "：" + hh + ":" + mf;
    },
    setMedicineName(data) {
      for (let i in this.systemReminderList) {
        if (this.systemReminderList[i].localhostId == data.id) {
          this.systemReminderList[i].name =
            this.systemReminderList[i].name +
            this.getTriggerTime(data.triggerTime);
        }
      }
    },
    deleteSystemReminder2(item) {
      this.$deleteSystemReminder(item.localhostId);
      if (item.id) {
        this.updateRemindWay(item);
      }
    },
    updateRemindWay(item) {
      let list = item.localhostIdTemp.split(",");
      let str = "";
      let re = item.remindWay;
      for (let i in list) {
        if (list[i] == item.localhostId) {
          list.splice(i, 1);
        }
      }
      str = list.toString();
      if (str == "") {
        re = item.remindWay.replace("3,", "").replace("3", "");
      }
      this.$post("/remind/updateRemindWay", [
        {
          id: item.id,
          remindWay: re, //提醒方式
          localhostId: str, //如果包含日历 先生成日历ID
          calendarId: item.calendarId
        }
      ])
        .then(res => {
          if (res.data.code == "200") {
            console.log("应用提醒删除成功！");
          }
        })
        .catch(e => {
          console.log(e);
        });
    },

    //删除本地提醒
    $deleteSystemReminder(list) {
      //删除提醒
      let data = remind.getDeleteSystemReminderData(list);
      DELETESYSTEMREMINDER(data);
    },
    // goSnapshot() {
    //   window.goSnapshot = () => {
    //     if (localStorage.token &&location.hash.indexOf("/guidePage") == -1 && location.hash.indexOf("/login") == -1) {
    //       this.utils.jumpNucleicAcids(this);
    //     }
    //   };
    // },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    webVersion: function() {
      // let data = {
      //   webAction:"webVersion",
      //   webVersion:'2.0.1'
      // }
      // if(window.webVersion && window.webVersion.call){//
      //       const result = window.webVersion.call(JSON.stringify(data))//添加日历
      // }
    },
    //图片转base 64
    getBase64: function(imgUrl) {
      var xhr = new XMLHttpRequest();
      xhr.open("get", imgUrl, true);
      // 至关重要
      xhr.responseType = "blob";
      xhr.onload = function() {
        if (this.status == 200) {
          //得到一个blob对象
          var blob = this.response;
          // 至关重要
          let oFileReader = new FileReader();
          oFileReader.onloadend = function(e) {
            let base64 = e.target.result;
            let data = {
              webAction: "saveShareImage",
              data: base64
            };
            if (window.saveShareImage && window.saveShareImage.call) {
              //
              const result = window.saveShareImage.call(JSON.stringify(data)); //二维码 转换成base64 调用后端
            }
          };
          oFileReader.readAsDataURL(blob);
        }
      };
      xhr.send();
    },
    //是否显示头部
    header: function(bool) {
      this.header_show = bool;
    },
    //是否显示底部
    footer: function(bool) {
      if (this.$route.query.bool) {
      }
      this.footer_show = bool;
    }
  }
};
</script>

<style lang="less">
.cropper-bg {
  background: #000;
}
.vacancy-box {
  position: sticky;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 99;
  background: transparent;
}

.add-body {
  padding-top: 0 !important;
}

// 设置诊籍关联和用药人的滚动条
.caseList,
.userList {
  &::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar {
    width: 3px !important;
    display: block !important;
    border-radius: 10px;
  }
}

.mint-header {
  .mint-header-button {
    img {
      width: 20px;
      height: 22px;
    }
  }

  .mint-header-title {
    color: #000000 !important;
    font-size: 16px !important;
    opacity: 0.9 !important;
  }
}

#app,
body {
  text-align: center;
  // position: fixed;
  // left: 0;
  // top: 0;
  background: #fafafa;
  height: 100vh;
  width: 100vw;
  overflow: scroll;
}

//mention 全局样式
.mention {
  color: #3676c8;
}

/* 路由转场样式 */
.slide-left-enter {
    transform: translate(100%);
}
.slide-left-enter-active {
    transition: all .3s ease-in-out;
}
.slide-left-leave-active {
    transform: translate(-100%);
    transition: all .3s ease-in-out;
}
.slide-back-enter {
    transform: translate(-100%);
}
.slide-back-enter-active {
    transition: all .3s ease-in-out;
}
.slide-back-leave-active {
    transform: translate(100%);
    transition: all .3s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/App.vue